var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"superbill-code-admin mt-page"},[_c('crud-table',{attrs:{"title":`Manage Superbill Codes for ${_vm.practiceName}`,"item-table":"superbill-code","item-name":"Code","new-item":_vm.newItem,"filters":_vm.filters,"display-fields":_vm.displayFields,"edit-fields":_vm.editFields}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }